// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16F-4","label":"styles_label__tH0hA"};